import { SortingState } from '@tanstack/react-table';
import { Prisma } from '@repo/common-types';

const { SortOrder } = Prisma;

export const convertSortingToApiFormat = (sorting: SortingState) => {
  return sorting.map((sort) => ({
    field: sort.id,
    order: sort.desc ? SortOrder.desc : SortOrder.asc,
  }));
};
